import { render, staticRenderFns } from "./MemberStatsTable.vue?vue&type=template&id=3502ff85&scoped=true&lang=pug&"
import script from "./MemberStatsTable.vue?vue&type=script&lang=js&"
export * from "./MemberStatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3502ff85",
  null
  
)

export default component.exports